module.exports = __webpack_public_path__ + "static/media/model-patrol-88-swb.63530ba7.webp";